import React, { useState, useEffect } from "react";
import { Box, Button, Grid } from "@mui/material";
import Select from "react-select";
import DueDiligenceCard from "../components/DueDiligenceCard";
import { companiesData } from "../data/dummyData";
import { statsData } from "../data/dummyStats";
import StatsCard from "./StatsCard";
import "../styles/DueDiligence.css";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { customSelectStyles } from "../../../common/input-fields/selectStyles";
import ShimmerCard from "../Shimmer/ShimmerCard";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { fetchCompanies } from "../services/api";

const industryOptions = [
  { value: "", label: "All Industries" },
  { value: "SaaS", label: "SaaS/PaaS" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Healthcare", label: "Healthcare" },
  { value: "E-commerce", label: "E-commerce" },
  { value: "Financial Services", label: "Financial Services" },
  { value: "Renewable Energy", label: "Renewable Energy" },
];

const gradients = [
  "linear-gradient(90deg, #1f61c5 0%, #1f60c2 45%, #2969c9 100%)",
  "linear-gradient(90deg, #ffb796 0%, #ffa796 20%, #fe8c96 61%, #fe9296 100%)",
  "linear-gradient(90deg, #3dd2be 0%, #53d4c4 49%, #1d9f91 88%, #1d9f91 100%)",
  "linear-gradient(90deg, #2d1cc6 0%, #2f36bc 49%, #343fc6 88%, #323bc4 100%)",
];

const statIcons = {
  1: "/icons/companies.svg",
  2: "/icons/docs.svg",
  3: "/icons/progress.svg",
  4: "/icons/risk.svg",
};

const DueDiligence = () => {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [totalCompanies, setTotalCompanies] = useState(0);
  const [selectedIndustry, setSelectedIndustry] = useState(industryOptions[0]);

  useEffect(() => {
    const getCompanies = async () => {
      try {
        setLoading(true);
        const response = await fetchCompanies();
        setCompanies(response);
        setTotalCompanies(response.length);
      } catch (err) {
        console.error("Error fetching companies:", err);
      } finally {
        setLoading(false);
      }
    };

    getCompanies();
  }, []);

  const filteredCompanies = companies.filter((company) => {
    const matchesSearch =
      company.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      company.industry?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesIndustry =
      !selectedIndustry || selectedIndustry.value === ""
        ? true
        : company.industry?.toLowerCase() ===
          selectedIndustry.value.toLowerCase();

    return matchesSearch && matchesIndustry;
  });

  // const handleAddCompany = (newCompanyFromApi) => {
  //   // Add the new company returned by API directly to state
  //   setCompanies((prev) => [
  //     ...prev,
  //     {
  //       ...newCompanyFromApi,
  //       ddProgress: newCompanyFromApi.dd_progress || 0,
  //       lastActivity: "Just now",
  //       risk: "Low Risk",
  //     },
  //   ]);
  // };

  return (
    <Box className="padding-20">
      {/* Header */}
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs="auto" sm={12}>
          <div className="dashboard-header">
            <div className="header-text">Due Diligence Portfolio</div>
            <span className="desc-text">
              Manage and analyze your target companies
            </span>
          </div>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            className="custom-btn"
            startIcon={<AddIcon />}
            onClick={() => navigate("/due-diligence/add-company")}
          >
            Add Company
          </Button>
        </Grid>
      </Grid>

      {/* Stats */}
      {/* <Grid container spacing={2} className="filters-grid">
        {statsData.map((stat, index) => (
          <Grid item md key={stat.id}>
            <StatsCard
              icon={statIcons[stat.id]}
              value={stat.value}
              label={stat.label}
              bg={gradients[index % gradients.length]}
            />
          </Grid>
        ))}
      </Grid> */}
      <Grid container spacing={2} className="filters-grid">
        {[
          { id: 1, value: totalCompanies, label: "Total Companies" },
          { id: 2, value: statsData[1].value, label: statsData[1].label },
          { id: 3, value: statsData[2].value, label: statsData[2].label },
          { id: 4, value: statsData[3].value, label: statsData[3].label },
        ].map((stat, index) => (
          <Grid item md key={stat.id}>
            <StatsCard
              icon={statIcons[stat.id]}
              value={stat.value}
              label={stat.label}
              bg={gradients[index % gradients.length]}
            />
          </Grid>
        ))}
      </Grid>

      {/* Search & Select */}
      <Grid
        container
        spacing={3}
        className="filters-grid"
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item xs="auto">
          <div className="search-wrapper" style={{ width: "100%" }}>
            <SearchIcon className="search-icon" />
            <input
              className="search-input"
              placeholder="Search companies by name or industry…"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </Grid>
        <Grid item xs={12}>
          <Select
            className="select-dropdown"
            styles={customSelectStyles}
            options={industryOptions}
            value={selectedIndustry}
            onChange={(option) => setSelectedIndustry(option)}
          />
        </Grid>
      </Grid>

      {/* Company Cards */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
            width: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2} className="card-grid">
          {filteredCompanies.map((company) => (
            <Grid item xs={12} sm={12} md={6} key={company.id}>
              <DueDiligenceCard company={company} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default DueDiligence;
